import { Pipe, PipeTransform } from '@angular/core';

const PROFILE_IMAGE_PLACEHOLDER = "https://assets.hyperinvento.com/hyperinventory_admin/dynamic-home-assets/common/john-doe-image.jpg";

const REVIEW_STAR_BLOCK_START = '<div class="ratings non-editable">';
const REVIEW_STAR_BLOCK_END = '</div>';
const REVIEW_BLOCK = '<span class="active non-editable">★</span>';

const REVIEW_DATE_BLOCK_START = '<p class="review-date non-editable">';
const REVIEW_DATE_BLOCK_END = '</p>';

@Pipe({ name: 'reviewInterpolation', standalone: true })
export class ReviewInterpolationPipe implements PipeTransform {

  transform(htmlString: string, response: any) {

    const { starRating = 5, createTime = "" } = response || {};

    // Managing review star Block
    const reviewStarBlockRegex = new RegExp(`${REVIEW_STAR_BLOCK_START}.*?${REVIEW_STAR_BLOCK_END}`, 'g');
    if (reviewStarBlockRegex) {
      htmlString = htmlString.replace(reviewStarBlockRegex, this.interPolateReviewStar(starRating));
    }

    // Managing review date Block
    const reviewDateBlockRegex = new RegExp(`${REVIEW_DATE_BLOCK_START}.*?${REVIEW_DATE_BLOCK_END}`, 'g');
    if (reviewDateBlockRegex) {
      htmlString = htmlString.replace(reviewDateBlockRegex, this.formatReviewDate(new Date(createTime)));
    }

    htmlString = htmlString.replace(/{{\s*(.*?)\s*}}/g, (_match, p1) => {
      let apiValue;

      // Always get value via path
      apiValue = this.getValueByPath(response, p1.trim());

      // Use fallback if value is undefined, null, or empty string
      if (apiValue === undefined || apiValue === null || apiValue === '') {
        // Special handling for image URLs or others if needed
        if (p1.includes('profilePhotoUrl')) {
          return PROFILE_IMAGE_PLACEHOLDER;
        }
        return ''; // Default fallback
      }

      return apiValue;
    });


    // Remove any HTML tags with 'undefined' or 'null' content
    const removeUndefinedNullTags = (html: string) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const elements = doc.body.querySelectorAll('*');

      elements.forEach(element => {
        if (element.textContent === 'undefined' || element.textContent === 'null') {
          element.remove();
        }
      });

      return doc.body.innerHTML;
    };

    htmlString = removeUndefinedNullTags(htmlString);

    return htmlString;
  }

  // Getting the path of nested object
  getValueByPath(obj: any, path: string): any {
    return path.split('.').reduce((acc, key) => {
      if (acc && key) {
        const match = key.match(/^(\w+)(\[(\d+)\])?(\?)?$/);
        if (match) {
          const [, propName, , arrayIndex, optional] = match;
          if (propName && optional && acc[propName] === undefined) {
            return undefined; // Return undefined if optional and property is undefined
          }
          if (propName) {
            acc = arrayIndex ? acc[propName]?.[parseInt(arrayIndex, 10)] : acc[propName];
          }
        }
      }
      return acc;
    }, obj);
  }

  interPolateReviewStar(numberOfStar: number) {
    let reviewStartBlock = REVIEW_STAR_BLOCK_START;
    for (let i = 0; i < numberOfStar; i++) {
      reviewStartBlock += REVIEW_BLOCK;
    }
    return reviewStartBlock += REVIEW_STAR_BLOCK_END;
  }

  formatReviewDate(date: Date) {
    if (!date || isNaN(date.getTime())) {
      return "";
    }
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHour = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHour / 24);
    const diffMonth = Math.floor(diffDay / 30);
    const diffYear = Math.floor(diffDay / 365);

    let timeline = "";
    if (diffYear >= 1) {
      timeline = diffYear === 1 ? "a year ago" : `${diffYear} years ago`;
    } else if (diffMonth >= 1) {
      timeline = diffMonth === 1 ? "a month ago" : `${diffMonth} months ago`;
    } else if (diffDay >= 1) {
      timeline = diffDay === 1 ? "a day ago" : `${diffDay} days ago`;
    } else if (diffHour >= 1) {
      timeline = diffHour === 1 ? "an hour ago" : `${diffHour} hours ago`;
    } else if (diffMin >= 1) {
      timeline = diffMin === 1 ? "a minute ago" : `${diffMin} minutes ago`;
    } else {
      timeline = "just now";
    }
    return `${REVIEW_DATE_BLOCK_START} ${timeline} ${REVIEW_DATE_BLOCK_END}`;
  }

}
